import React from "react";
import {
  FaCcVisa,
  FaCcMastercard,
  FaCcDiscover,
  FaCcJcb,
  FaCcDinersClub,
} from "react-icons/fa";
import { LiaCcAmex } from "react-icons/lia";
import { MdCreditCard } from "react-icons/md"; // Generic icon

const CardIconForBrand = ({ brand }) => {
  const brandLowerCase = brand.toLowerCase();

  const options = {
    visa: <FaCcVisa style={{ fontSize: "2rem" }} />,
    mastercard: <FaCcMastercard style={{ fontSize: "2rem" }} />,
    amex: <LiaCcAmex style={{ fontSize: "2.4rem" }} />,
    jcb: <FaCcJcb style={{ fontSize: "2rem" }} />,
    discover: <FaCcDiscover style={{ fontSize: "2rem" }} />,
    dinersclub: <FaCcDinersClub style={{ fontSize: "2rem" }} />,
  };

  return (
    <div style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      paddingRight: "10px"
    }}>
      {options[brandLowerCase] || <MdCreditCard style={{ fontSize: "2rem" }} />}
    </div>
  );
};

export default CardIconForBrand;
